export default {
    cash: "Cash upon receipt",
    online: "Online pay",
    bank_card: "Bank card",
    alfabank: "Alfa-Click",
    sbp: "SBP",
    tinkoff_bank: "Tinkoff",
    yoo_money: "Yoo Money",
    qiwi: "QIWI Wallet",
    sberbank: "SberPay",
    mobile_balance: "Mobile Balance"
}
